// The two custom route builders, shared by the CTAs that choose between them and the explore app that serves them
export const standardBuilderPath = '/explore/custom-routes';
export const advancedBuilderPath = '/adv/custom-routes';

export type CustomRouteBuilderPath = typeof standardBuilderPath | typeof advancedBuilderPath;
